import { render, staticRenderFns } from "./ot-contract-details.vue?vue&type=template&id=2c485c2a&scoped=true&"
import script from "./ot-contract-details.vue?vue&type=script&lang=ts&"
export * from "./ot-contract-details.vue?vue&type=script&lang=ts&"
import style0 from "./ot-contract-details.vue?vue&type=style&index=0&id=2c485c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c485c2a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
